import { api } from '../core';
import { BUNDLE_UNDO_REDO_HISTORY_TAG } from '../constants';
import { RootState, setBundleUndoRedoHistory } from '@/store';

export interface BundleUndoRedoHistory {
  undone: number;
  applied: number;
}

type BundleUndoRedoHistoryResponse = BundleUndoRedoHistory;

type BundleUndoRedoHistoryProps = {
  bundleId: string;
};

export const getBundleUndoRedoHistoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBundleUndoRedoHistory: builder.query<BundleUndoRedoHistoryResponse, BundleUndoRedoHistoryProps>({
      query: ({ bundleId }: BundleUndoRedoHistoryProps) => {
        return {
          url: `bundle/history`,
          method: 'GET',
          params: {
            bundleId: bundleId
          }
        };
      },
      providesTags: (_result, _err, { bundleId }) => [{ type: BUNDLE_UNDO_REDO_HISTORY_TAG, id: bundleId }],
      async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          const state = getState() as RootState;
          const resolvedBundleKey = state.sharedData.activeBundleType;

          if (resolvedBundleKey && data) {
            dispatch(
              setBundleUndoRedoHistory({
                key: resolvedBundleKey,
                data: data
              })
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getBundleUndoRedoHistory in onQueryStarted:', error);
          }
        }
      }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetBundleUndoRedoHistoryQuery } = getBundleUndoRedoHistoryApi;
